'use client'

import { GeolocationContext } from '@components/hooks/GeolocationProvider/index.client'
import { Icon } from '@components/primitives/Icon'
import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import { classMerge } from '@components/utilities/classMerge'
import { faHospital } from '@fortawesome/pro-regular-svg-icons/faHospital'
import { type ExternalImage } from '@prisma/client'
import { useContext, useEffect, useState } from 'react'
import getTrialListingImageAction from './getTrialListingImageAction'

export const TrialListingImageWithUserLocation = ({
  className,
  nctId,
}: {
  className?: string
  nctId: string
}) => {
  const userLocation = useContext(GeolocationContext)
  const [images, setImages] = useState<ExternalImage[]>()

  useEffect(() => {
    const getImage = async () => {
      if (!userLocation.latitude || !userLocation.longitude) return

      const result = await getTrialListingImageAction({
        nctId,
        ...userLocation,
      })
      if (result.success) {
        setImages(result.value.trialListingImages)
      }
    }
    getImage()
  }, [userLocation, nctId])

  const image = images?.[0]

  if (!userLocation.latitude || !userLocation.longitude || !image) {
    return (
      <div
        className={classMerge(
          'flex items-center justify-center bg-white',
          className,
        )}
      >
        <Icon className='text-primary600' icon={faHospital} size='2x' />
      </div>
    )
  }

  return (
    <CloudflareImage
      alt={image.altText ?? 'Trial Listing Image'}
      className={className}
      imageId={image.externalId}
    />
  )
}
